/* fitlibrary-hero.js — Campaign hero scene.
   Two behaviours, both optional and both progressive enhancements:
     1) Entrance assembly. The CSS composition is already final without JS;
        this file adds `.chero--anim` first, which is what arms the offset
        start state, then `.is-in` to play it. So a no-JS visitor sees the
        finished scene rather than an empty one.
     2) Micro-parallax. The whole world moves as ONE object, 3px x / 2px y,
        fine pointers on desktop only.
   Neither runs under prefers-reduced-motion. Re-initialises on
   shopify:section:load so the theme editor stays live.

   2026-08-19 · SCROLL MOTION HANDOFF. The settle callback now also adds
   `.is-depth`, which is what arms the per-layer scroll depth rule in
   assets/fitlibrary-motion.css. It is deliberately tied to the END of the
   1500ms settle: the entrance animates .chero__p transforms, and the depth
   parallax writes the same property, so arming it earlier would let the two
   fight mid-assembly. Under reduced motion this whole branch never runs, so
   .is-depth is never added and the layers stay exactly as authored. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    var hero = (root || document).querySelector('[data-hero]');
    if (!hero || hero.dataset.heroReady === '1') return;
    var scene = hero.querySelector('[data-hero-scene]');
    if (!scene) return;
    hero.dataset.heroReady = '1';

    var imgs = Array.prototype.slice.call(scene.querySelectorAll('img'));
    var settleTimer;

    /* Wait for the layers so they assemble together rather than popping in one
       at a time — capped, so one slow asset can't hold the first viewport
       hostage. */
    function whenReady(done) {
      var left = imgs.length, fired = false;
      function finish() { if (fired) return; fired = true; done(); }
      function tick() { if (--left <= 0) finish(); }
      if (!left) return finish();
      imgs.forEach(function (img) {
        if (img.complete && img.naturalWidth) return tick();
        img.addEventListener('load', tick, { once: true });
        img.addEventListener('error', tick, { once: true });
      });
      setTimeout(finish, 1200);
    }

    if (!reduce.matches) {
      hero.classList.add('chero--anim');
      whenReady(function () {
        requestAnimationFrame(function () {
          scene.classList.add('is-in');
          /* Drop the compositing hint once everything has landed so the layers
             re-rasterise at final resolution and stay crisp, and hand the
             layer transforms over to the scroll depth effect. */
          clearTimeout(settleTimer);
          settleTimer = setTimeout(function () {
            scene.classList.add('is-settled');
            scene.classList.add('is-depth');
          }, 1500);
        });
      });
    }

    var px = 0, py = 0, ticking = false, bound = false;
    function apply() {
      ticking = false;
      scene.style.setProperty('--px', px.toFixed(2) + 'px');
      scene.style.setProperty('--py', py.toFixed(2) + 'px');
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }
    function onMove(e) {
      var r = hero.getBoundingClientRect();
      if (!r.width || !r.height) return;
      px = ((e.clientX - r.left) / r.width - 0.5) * 6;
      py = ((e.clientY - r.top) / r.height - 0.5) * 4;
      queue();
    }
    function onLeave() { px = 0; py = 0; queue(); }

    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var wide = window.matchMedia('(min-width: 901px)');
    function sync() {
      var want = fine.matches && wide.matches && !reduce.matches;
      if (want && !bound) {
        hero.addEventListener('mousemove', onMove);
        hero.addEventListener('mouseleave', onLeave);
        bound = true;
      } else if (!want && bound) {
        hero.removeEventListener('mousemove', onMove);
        hero.removeEventListener('mouseleave', onLeave);
        bound = false;
        onLeave();
      }
    }
    sync();
    [fine, wide, reduce].forEach(function (mq) {
      if (mq.addEventListener) mq.addEventListener('change', sync);
      else if (mq.addListener) mq.addListener(sync);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
